import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import useRelatorioEstadia, { LOAD_MESSAGE } from './RelatorioEstadiaHook'
import { hideLoadingBox, showMessageBox } from '../../../../store/actions/system.actions'
import {
  Btn,
  CustomCardColorBar,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  NumeroDecimal,
  PageHeader,
  SectionTitle,
} from '../../../../components'
import { tableCellCenteredWithPercentage } from '../../../../assets/js/styles'
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'
import ModalPosicaoRelatorioEstadia from './ModalPosicaoRelatorioEstadia'
import * as colors from '../../../../assets/js/colors'

function RelatorioEstadia({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useRelatorioEstadia()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_ESTADIA:
        dispatch(hideLoadingBox())
        localDispatch.getPosicoesEstoqueFromCompany(selectedTp, state.selectedEmpresa.id)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>8.8 - Relatório de Estadia por Empresa</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <React.Fragment>
            <div className="p-grid">
              <div className="p-col-3">
                <CustomDropdown
                  disabled={!selectedTp}
                  filter={true}
                  label={'Empresa'}
                  optionLabel={'name'}
                  onChange={value => localDispatch.onChange('selectedEmpresa', value)}
                  options={getEmpresas().map(e => ({ id: e.id, name: e.name }))}
                  value={state.selectedEmpresa}
                />
              </div>
              <div className="p-col-3" style={{ marginTop: 25 }}>
                <Btn
                  disabled={!selectedTp || !state.selectedEmpresa}
                  onClick={() =>
                    localDispatch.onClickGerarExcel(state.posicoes, state.selectedEmpresa)
                  }
                >
                  Exportar Excel
                </Btn>
              </div>
              <div className="p-col-12">
                <SectionTitle title={'Informações'} />
              </div>
              <div className="p-col-12 p-md-6">
                <CustomCardColorBar
                  value={state.informacoes.tempo_maximo}
                  title={'Tempo máximo de estadia'}
                  subTitle={`em dias`}
                  barColor={colors.vermelho}
                />
              </div>
              <div className="p-col-12 p-md-6">
                <CustomCardColorBar
                  value={state.informacoes.tempo_medio}
                  title={'Tempo médio de estadia'}
                  subTitle={`em dias`}
                  barColor={colors.azul_escuro}
                />
              </div>
              <div className="p-col-12 p-md-6">
                <CustomCardColorBar
                  value={state.informacoes.posicoes_ocupadas}
                  title={'Posições ocupadas'}
                  subTitle={`em un`}
                  barColor={colors.black}
                />
              </div>
              <div className="p-col-12 p-md-6">
                <CustomCardColorBar
                  value={<NumeroDecimal>{state.informacoes.total_volumes}</NumeroDecimal>}
                  title={'Total de Volumes'}
                  subTitle={`em caixas`}
                  barColor={colors.pink}
                />
              </div>
              <div className="p-col-12">
                <SectionTitle title={'Posições de Estoque Ocupadas'} />
              </div>
              <div className="p-col-12">
                <div style={{ marginTop: 15 }}>
                  <DataTable
                    onRowClick={e =>
                      localDispatch.onChange('selectedPosicao', e.data.posicao_estoque_id)
                    }
                    selectionMode="single"
                    value={state.posicoes}
                    emptyMessage="Não existe movimentação de expedição para o TP selecionado."
                    paginator={true}
                    rows={15}
                    globalFilter={state.globalFilter}
                    header={<CustomDataTableHeader onChange={localDispatch.globalFilterChanged} />}
                  >
                    <Column
                      field="estoque_name"
                      header="Estoque"
                      style={tableCellCenteredWithPercentage(25)}
                    />
                    <Column
                      field="posicao_endereco"
                      header="Posição"
                      style={tableCellCenteredWithPercentage(35)}
                    />
                    <Column
                      sortable="true"
                      field="data_entrada"
                      header="Data de Entrada Mais Antiga"
                      style={tableCellCenteredWithPercentage(15)}
                    />
                    <Column
                      sortable="true"
                      field="volumes"
                      header="Volumes"
                      style={tableCellCenteredWithPercentage(10)}
                      body={item => <NumeroDecimal>{item.volumes}</NumeroDecimal>}
                    />
                    <Column
                      sortable="true"
                      field="tempo_decorrido"
                      header="Tempo Decorrido"
                      style={tableCellCenteredWithPercentage(10)}
                    />
                  </DataTable>
                </div>
              </div>
            </div>
          </React.Fragment>
        </CustomPanel>
      </div>
      <ModalPosicaoRelatorioEstadia
        isVisible={state.showModal}
        posicaoId={state.selectedPosicao}
        onClose={localDispatch.onCloseModal}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(RelatorioEstadia))
